import {
    SET_TANGIBLE_VIEW,
    UPDATE_TANGIBLE_FIELD,
    SET_TANGIBLE_CONTRACT,
    SET_TANGIBLE_SUB_TYPE,
    SET_TANGIBLE_SECONDARY_TYPE,
    SET_TANGIBLE_TERTIARY_TYPE,
    SET_TANGIBLE_TASK_ORDER,
    SET_TANGIBLE_ACCOUNTING
} from "../types";

const initialState = {
    data: {},
    lists: {},
    contacts: {},
    view: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_TANGIBLE_FIELD:
            return {
                ...state,
                data: payload
            };
        case SET_TANGIBLE_VIEW:
            return {
                ...state,
                data: payload.data,
                contacts: payload.contacts,
                view: {
                    ...state.view,
                    skeleton: payload.skeleton,
                    dropdowns: payload.dropdowns,
                    validation_rules: payload.validation_rules
                }
            };
        case SET_TANGIBLE_CONTRACT:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: {
                        ...state.view.dropdowns,
                        contracts: payload
                    }
                }
            };
        case SET_TANGIBLE_SUB_TYPE:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: {
                        ...state.view.dropdowns,
                        subtype: payload
                    }
                }
            };
        case SET_TANGIBLE_SECONDARY_TYPE:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: {
                        ...state.view.dropdowns,
                        status_secondary: payload
                    }
                }
            };
        case SET_TANGIBLE_TERTIARY_TYPE:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: {
                        ...state.view.dropdowns,
                        status_tertiary: payload
                    }
                }
            };
        case SET_TANGIBLE_TASK_ORDER:
            return {
                ...state,
                lists: {
                    ...state.lists,
                    task_orders: payload
                }
            };
        case SET_TANGIBLE_ACCOUNTING:
            return {
                ...state,
                lists: {
                    ...state.lists,
                    accounting: payload
                }
            };
        default:
            return state;
    }
}